import 'focus-visible';
import * as React from 'react';
import { IconButton } from '@dropbox/dig-components/buttons';
import { UIIcon } from '@dropbox/dig-icons';
import { Menu, } from '@dropbox/dig-components/menu';
import { Tooltip } from '@dropbox/dig-components/tooltips';
/**
 * Generic component used to standardize the utility items in the "Utility Nav" or right
 * container of IconButton / Menu combos.
 */
export const UtilityActionMenu = ({ iconSrc, children, customTriggerContents, triggerProps, wrapperActionProps, menuContentProps, tooltipTitle, slideSubmenu = false, }) => {
    return (React.createElement("div", { className: "dpc-GlobalHeader-UtilityItem" },
        React.createElement(Menu.Wrapper, { ...wrapperActionProps, slideSubmenu: slideSubmenu }, ({ getTriggerProps, getContentProps, triggerRef }) => {
            const trigger = (React.createElement(IconButton, { variant: "transparent", ...getTriggerProps(triggerProps), size: "medium" },
                !!iconSrc && React.createElement(UIIcon, { src: iconSrc, size: "medium" }),
                !!customTriggerContents && customTriggerContents));
            return (React.createElement(React.Fragment, null,
                tooltipTitle ? (React.createElement(Tooltip, { title: tooltipTitle, triggerRef: triggerRef }, trigger)) : (trigger),
                React.createElement("div", null,
                    React.createElement(Menu.Content, { ...getContentProps(), ...menuContentProps, placement: "bottom-end", positioningStrategy: "fixed" }, children))));
        })));
};
